import { render, staticRenderFns } from "./ElementPopover.vue?vue&type=template&id=695853a8&scoped=true"
import script from "./ElementPopover.vue?vue&type=script&lang=js"
export * from "./ElementPopover.vue?vue&type=script&lang=js"
import style0 from "./ElementPopover.vue?vue&type=style&index=0&id=695853a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695853a8",
  null
  
)

export default component.exports